import { createContext, useContext } from 'react';

export interface SnackbarValue {
    /** Shows the translated text for an error (ApiError name → `errors.*`); silent on 401. */
    showError(error: unknown): void;
    /** Shows an already translated success message. */
    showSuccess(message: string): void;
}

export const SnackbarContext = createContext<SnackbarValue | null>(null);

export function useSnackbar(): SnackbarValue {
    const value = useContext(SnackbarContext);
    if (!value) {
        throw new Error('useSnackbar must be used inside <SnackbarProvider>');
    }
    return value;
}
